/*
* Copyright (c) 2009-2019. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

export const rolesMapping = Object.freeze({
  'ROLE_GUEST': {label: 'guest', index: 0, class: 'is-light'},
  'ROLE_USER': {label: 'user', index: 1, class: 'is-link'},
  'ROLE_ADMIN': {label: 'admin', index: 2, class: 'is-success'},
  'ROLE_SUPER_ADMIN': {label: 'super-admin', index: 3, class: 'is-success'},
});
